export const mockExperts = [
  {
    id: 'expert-1',
    name: 'Lerato Mokoena',
    initials: 'LM',
    role: 'Senior Storage Engineer',
    organization: 'Eskom',
    country: 'South Africa',
    avatarColor: 'hsl(160 81% 17%)',
    isCoEAlumni: true,
    coEYear: '2025',
    credentials: ['BESS 101', 'Procurement'],
    answerCount: 14,
    availability: 'AVAILABLE'
  },
  {
    id: 'expert-2',
    name: 'Amara Okafor',
    initials: 'AO',
    role: 'Grid Planner',
    organization: 'NDPHC',
    country: 'Nigeria',
    avatarColor: 'hsl(195 54% 35%)',
    isCoEAlumni: true,
    coEYear: '2024',
    credentials: ['Grid Digitization', 'BESS 101'],
    answerCount: 8,
    availability: 'AVAILABLE'
  },
  {
    id: 'expert-3',
    name: 'Dr. Daniel Tesfaye',
    initials: 'DT',
    role: 'Grid Integration Specialist',
    organization: 'Ethiopian Electric Power',
    country: 'Ethiopia',
    avatarColor: 'hsl(195 54% 45%)',
    isCoEAlumni: true,
    coEYear: '2025',
    credentials: ['Grid Integration', 'Renewables'],
    answerCount: 22,
    availability: 'AVAILABLE'
  },
  {
    id: 'expert-4',
    name: 'Priya Nair',
    initials: 'PN',
    role: 'Tender Advisory Lead',
    organization: 'Independent Consultant',
    country: 'India',
    avatarColor: 'hsl(310 22% 55%)',
    isCoEAlumni: false,
    credentials: ['Procurement', 'Contracting'],
    answerCount: 31,
    availability: 'LIMITED'
  },
  {
    id: 'expert-5',
    name: 'Joseph Mwangi',
    initials: 'JM',
    role: 'Project Developer',
    organization: 'SolarAfrica',
    country: 'Kenya',
    avatarColor: 'hsl(154 48% 35%)',
    isCoEAlumni: true,
    coEYear: '2024',
    credentials: ['Mini-grids', 'Project Finance'],
    answerCount: 12,
    availability: 'AVAILABLE'
  }
];
